import {
  Container,
  ContainerGutter,
  ContainerWrap,
  CTA,
  styled,
  Text,
  TextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useSelector } from 'react-redux';
import { useIsComerciales } from 'src/feature-app/hooks';
import { OneFormState } from 'src/types';

const PaddingWrapper = styled.div`
  padding-top: 32px;
`;

const TextColor = styled.span`
  color: #6a767d;
`;

const linkLegalesEurocopa = 'https://crm.volkswagen.es/cms/2021/legal_concurso_eurocopa_2021.pdf';


interface LegalesProps {
  showBasesLegales?: boolean;
  showBasesLegalesTestID2023?: boolean;
}
export const Legales = (props: LegalesProps) => {
  const isComerciales = useIsComerciales();
  return isComerciales ? <LegalesComerciales /> : <LegalesTurismos {...props} />;
};

const LegalesTurismos = (props: LegalesProps) => {
  const { hideLegal, customLegal } = useSelector((state: OneFormState) => state.formInfo);
  return (
    <PaddingWrapper>
      {customLegal ? customLegal : null}
      {hideLegal ? null : (
        <Container gutter={ContainerGutter.static200} wrap={ContainerWrap.always}>
          <Text bold appearance={TextAppearance.copy0200}>
            <TextColor>Texto legal de Volkswagen</TextColor>
          </Text>
          <Text appearance={TextAppearance.copy0150}>
            <TextColor>
              Te informamos que el responsable del tratamiento de tus datos es la compañía VOLKSWAGEN GROUP ESPAÑA
              DISTRIBUCION, S.A.U., con la finalidad de atender tus consultas y solicitudes, realizar un control de
              calidad sobre los productos y servicios solicitados, realizar encuestas de opinión y estudios de mercado
              con fines estadísticos. En caso que nos hayas dado tu consentimiento, para las finalidades descritas en
              los consentimientos adicionales.
            </TextColor>
          </Text>
          <Text appearance={TextAppearance.copy0150}>
            <TextColor>
              Te informamos que tienes derecho a retirar tu consentimiento en cualquier momento, así como a oponerte al
              tratamiento, limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a la
              portabilidad, mediante petición escrita a{' '}
              <CTA tag="a" href="mailto:atencioncliente@volkswagen.es" target="_blank" emphasis="tertiary">
                <b>atencioncliente@volkswagen.es</b>
              </CTA>
              .
            </TextColor>
          </Text>
          <Text appearance={TextAppearance.copy0150}>
            <TextColor>
              Puedes consultar con mayor detalle la información adicional sobre la política de privacidad{' '}
              <CTA
                tag="a"
                href="https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html"
                target="_blank"
                emphasis="tertiary"
              >
                <b>aquí</b>
              </CTA>
              .
            </TextColor>
          </Text>
          {props.showBasesLegales ? (
            <Text staticSize appearance={TextAppearance.copy0150}>
              <TextColor>
                Consulta las{' '}
                <CTA tag="a" href={linkLegalesEurocopa} target="_blank" emphasis="tertiary">
                  <b>Bases Legales</b>
                </CTA>{' '}
                de la promoción.
              </TextColor>
            </Text>
          ) : null}
        </Container>
      )}
    </PaddingWrapper>
  );
};
const LegalesComerciales = (props: LegalesProps) => {
  const { hideLegal } = useSelector((state: OneFormState) => state.formInfo);
  return (
    <PaddingWrapper>
      {hideLegal ? null : (
        <Container gutter={ContainerGutter.static200} wrap={ContainerWrap.always}>
          <Text bold appearance={TextAppearance.copy0200}>
            <TextColor>Texto legal de Volkswagen</TextColor>
          </Text>
          <Text appearance={TextAppearance.copy0150}>
            <TextColor>
              Vamos a utilizar tus datos para el mantenimiento, desarrollo y/o control de nuestra relación comercial;
              atender a tus consultas y solicitudes; realizar un control de calidad sobre los productos y servicios por
              los que te hayas interesado; realización de encuestas de opinión y estudios de mercado con fines
              estadísticos.
            </TextColor>
            <TextColor>
              Tus datos se enviarán al concesionario que hayas seleccionado, si has seleccionado alguno, para la
              prestación del servicio solicitado o dar respuesta a la petición que hayas realizado (por ejemplo la
              prueba de un vehículo o envío de un presupuesto solicitado).
            </TextColor>
          </Text>
          <Text appearance={TextAppearance.copy0150}>
            <TextColor>
              Tienes derecho a retirar tus consentimientos en cualquier momento, así como oponerte al tratamiento,
              limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a portabilidad, mediante el
              envío de un mail a{' '}
              <CTA tag="a" href="mailto:atencioncliente@volkswagen-comerciales.es" target="_blank" emphasis="tertiary">
                <b>atencioncliente@volkswagen-comerciales.es</b>
              </CTA>
              .
            </TextColor>
          </Text>
          <Text appearance={TextAppearance.copy0150}>
            <TextColor>
              Puedes consultar con mayor detalle la Información adicional sobre Protección de Datos{' '}
              <CTA
                tag="a"
                href="https://www.volkswagencomerciales.es/v2/pdf/Formulario_RGPD_certificacion_Capa2_2019_v2.pdf"
                target="_blank"
                emphasis="tertiary"
              >
                <b>aquí</b>
              </CTA>
              .
            </TextColor>
          </Text>
        </Container>
      )}
    </PaddingWrapper>
  );
};
